import {DomainEvent} from './DomainEvent';
import {Coach} from '../resources/Coach';

export class CoachAdded extends DomainEvent<Coach> {}

export class RefreshCoachAdded extends CoachAdded {}